module.exports = __webpack_public_path__ + "static/media/zDAI.61fd067a.png";